<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>design_services</md-icon>driver_business_type
          </div>
          <h4 class="title">
            Client Information
          </h4>
        </md-card-header> -->
        <input v-model="client.id" :readonly="true" type="hidden"/>
        <md-card-content>
          <div class="md-layout-item md-small-size-100">
            <validation-provider rules="businesstype" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Business Type</label>
              <md-select v-model="driver_business_type" required >
                <md-option value="1">TAXI</md-option>
                <md-option value="2">RENTAL</md-option>
              </md-select>
              <validation-error :errors="apiValidationErrors.driver_business_type" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
          <md-button :disabled="!driver_business_type" disable="" class="md-icon-text md-round md-primary" v-on:click="findClient()">Find Client/Driver</md-button>
          <div class="md-layout" style="margin-top:10px;">
            
            <div class="md-layout-item md-small-size-100">
              <div class="md-layout-item">
                <validation-provider rules="driverno" ref="driver_no" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label for="">Driver No</label>
                  <md-input v-model="client.driver_no" readonly required/>
                  <validation-error :errors="apiValidationErrors.driver_no" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="md-layout" style="margin-top:10px;">
            <div class="md-layout-item md-small-size-50">
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <label for="">Driver Name</label>
                  <md-input v-model="client.driver_name" readonly/>
                </md-field>
              </div>
            </div>
            <div class="md-layout-item md-small-size-50">
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <label for="">Driver Nickname</label>
                  <md-input v-model="client.driver_nickname" readonly/>
                </md-field>
              </div>
            </div>
          </div>
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Phone</span>
            </label> -->
          <div class="md-layout">
            <div class="md-layout-item md-small-size 50">
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <label for="">Driver Phone</label>
                  <md-input v-model="client.driver_phone_no" readonly/>
                </md-field>
              </div>
            </div>
            <div class="md-layout-item md-small-size 50">
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <label for="">Address</label>
                  <md-input v-model="client.driver_address" readonly/>
                </md-field>
              </div>
            </div>
            
          </div>
            
        </md-card-content>
      </md-card>  
    </div>
    <modal ref="modalList" class="coba">
      <template v-slot:header>
        <div>
          <h3>List Driver</h3>
        </div>
        <md-button class="md-dense md-round md-icon-button" @click="modalCloseListDriver()"><md-icon>close</md-icon></md-button>
      </template>

      <template v-slot:body>
        <list-driver  :data_id="$refs.modalList.data"/>
      </template>

      <!-- <template v-slot:footer>
        <md-card-actions>
          <md-button @click="modalCloseList">
            Close
          </md-button>
        </md-card-actions>
      </template> -->
    </modal>
  </div>
</template>
<script>
import { Modal } from "@/components";
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import {extend} from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';

import ListDriver from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/modal/ListDriver.vue";

extend('driverno', {
  ...required,
  message: 'Please select driver first'
  });
  

export default {
  name: "driver-card",
  // props: {
  //   s: null,
  // },

  props: ['service_estimate'],

  components: { ValidationError,Modal,"list-driver": ListDriver
 },

  mixins: [formMixin],

  
   data: () => ({
     client: [],
      shouldDisable: true,
      driver_business_type: null
    }),
  methods: {
    
    async findClient(){
      this.$refs.modalList.openModal(this.driver_business_type)

    },
    //fungsi yang dipanggil dari sisi parent untuk mendapatkan data di child ini
    getData() {
        this.$emit('data', this.client)
       
    },
    //fungsi untuk mendapatkan data dari parent, digunakan pada saat edit
    getDataParent() {
       if(this.service_estimate.service_estimate_client !=null){
        this.client= this.service_estimate.service_estimate_client
        this.driver_business_type = this.service_estimate.service_estimate_client_driver_business_type
       }
    },
    //fungsi yang di panggil dari sisi parent untuk mengecheck validasi form di child ini
    async validateForm() {
      const driver_no = this.$refs['driver_no'];
    let result = []
      
      result.push(
        await driver_no.validate().then(function(data){
          return data.valid
        })
      )
      return result.every(Boolean)
    },
    //fungsi untuk menutup modal list client
    modalCloseListDriver(data){
      if(data && data.id){
      this.client = data
      this.client.driver_business_type = this.driver_business_type
      }
      this.$refs.modalList.closeModal()
    },

  },
  
};
</script>

<style lang="scss" scoped>
.md-layout-item{
  margin-top:10px;
}

.coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>
